import { Headers } from '@egw/components'
import { InvestmentsTradeDetails } from '@egw/features-transactions'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsActivityTradesDetailsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment.title')} />
      <InvestmentsTradeDetails />
    </Layout>
  )
}
